import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';

@Component({
  selector: 'ispm-json-editor',
  templateUrl: './json-editor.component.html',
  styleUrls: ['./json-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('JsonConfigEditor')
export class JsonEditorConfigComponent implements OnInit, IWidgetItem<any> {
  public editorOptions: JsonEditorOptions;
  public data: any;

  widgetUpdateValueCallback: (value: any) => void ;
  @ViewChild(JsonEditorComponent, { static: false, read: ViewContainerRef }) editor: JsonEditorComponent;

  constructor(private _changeDetector: ChangeDetectorRef,) {
    this.editorOptions = new JsonEditorOptions()
    this.editorOptions.modes = ['code', 'text', 'tree', 'view'];
  }

  set widgetData(widgetData: any) {
    this.data = widgetData;
  }

  ngOnInit(): void {
  }
}
